
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.7053 5.29501C15.0982 5.68836 15.0982 6.3261 14.7053 6.71945L9.42947 12L14.7053 17.2805C15.0982 17.6739 15.0982 18.3116 14.7053 18.705C14.3123 19.0983 13.6751 19.0983 13.2821 18.705L7.29474 12.7122C6.90175 12.3189 6.90175 11.6811 7.29474 11.2878L13.2821 5.29501C13.6751 4.90166 14.3123 4.90166 14.7053 5.29501Z","fill":"#10001F"}})])
          )
        }
      }
    